'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../dist-es6/client/formatters');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const CustomError=require('pulsar-utils/dist-es6/customError');
const BaseController=require('../../../dist-es6/client/angularCommon/baseController');let

BaseRealtimeUpdateController=class BaseRealtimeUpdateController extends BaseController{
constructor(uncaughtErrorHandler,$scope,$timeout,$interval,dateService,delayBetweenUpdates,countdownFrequency,timeZoneService){
super(uncaughtErrorHandler,$timeout);
this._$scope=$scope;
this._$timeout=$timeout;
this._$interval=this.preventRealtimeDigests?setInterval:$interval;
this._clearInterval=this.preventRealtimeDigests?clearInterval:this._$interval.cancel;
this._dateService=dateService;
this._delayBetweenUpdates=delayBetweenUpdates;
this._countdownFrequency=countdownFrequency;
this._timeZoneService=timeZoneService;

this._timeUntilNextUpdate=null;

if(this.visibleTimeZone){
this._$scope.$watch('controller.visibleTimeZone',()=>this._checkUpdateStatus());
}
}

_beginUpdates(){
this._checkUpdateStatus();
this._countdownCancellationToken=this._$interval(()=>this._checkUpdateStatus(),this._countdownFrequency.totalMilliseconds());

this._$scope.$on('$destroy',()=>{
this._clearInterval(this._countdownCancellationToken);
});
}

get timeUntilNextUpdate(){
return this._timeUntilNextUpdate;
}

async startNextUpdate(){
if(this._isUpdating){
return;
}

this._updateTimeUntilNextUpdate(null);
this.timeOfNextUpdate=null;

let completed=!1;
while(!completed){
try{
await this._update();
this._lastUpdateTime=this._dateService.now();
completed=!0;
}catch(err){
if(err instanceof UpdateFailedError){
continue;
}
throw err;
}
}

this._updateTimeUntilNextUpdate(this._delayBetweenUpdates);
}

async _updateTimeUntilNextUpdate(newValue){
this._timeUntilNextUpdate=newValue;

if(this.preventRealtimeDigests){
return;
}

return await this._$scope.$evalAsync(_.noop);
}

_checkUpdateStatus(){
if(this._isUpdating){
return;
}

this.timeOfNextUpdate=_.exists(this._lastFetchTime)?
pulsarDate(this._lastFetchTime).plus(this._delayBetweenUpdates):
this._dateService.now();

let timeUntilNextUpdate=pulsarDate(this.timeOfNextUpdate).minus(this._dateService.now());

if(timeUntilNextUpdate.totalMilliseconds()<this._countdownFrequency.totalMilliseconds()){
this.startNextUpdate();
}else
{
this._updateTimeUntilNextUpdate(timeUntilNextUpdate);
}
}

get timeOfNextUpdateString(){
return this._timeOfNextUpdateString;
}

get timeOfNextUpdate(){
return this._timeOfNextUpdate;
}

get lastUpdateTime(){
return this._lastUpdateTime;
}

set timeOfNextUpdate(nextUpdateTime){
const displayTimeZone=this.visibleTimeZone||this._timeZoneService.localTimeZone;
if(this._timeOfNextUpdate&&nextUpdateTime&&this._timeOfNextUpdate.getTime()===nextUpdateTime.getTime()&&this._lastUsedTimeZone&&displayTimeZone===this._lastUsedTimeZone){
return;
}

this._timeOfNextUpdateString=nextUpdateTime!==null?
'Next update at '+Formatters.timeInLocale(nextUpdateTime,displayTimeZone,!0,this.use24HourTimeline):
'Updating...';

this._lastUsedTimeZone=displayTimeZone;
this._timeOfNextUpdate=nextUpdateTime;

this._$scope.$evalAsync(_.noop);
}

async _update(){
throw new Error('abstract');
}

get _lastFetchTime(){
throw new Error('abstract');
}

get _isUpdating(){
throw new Error('abstract');
}};let


UpdateFailedError=class UpdateFailedError extends CustomError{constructor(){super('UpdateFailedError')}};

module.exports=BaseRealtimeUpdateController;
module.exports.UpdateFailedError=UpdateFailedError;
//# sourceMappingURL=baseRealtimeUpdateController.js.map
